import Image from 'next/image';

export default function ProjectStatus({ project, iconOnly, ...opts }) {
  const status = projectStatus(project);
  if (!status) return null;

  const isIconOnly = iconOnly === true;
  return (
    <div {...opts}>
      <Image
        src={STATUS_ICONS[status]}
        alt={isIconOnly ? STATUS_NAMES[status] : ''}
        width={16}
        height={16}
      />
      {isIconOnly ? null : ` ${STATUS_NAMES[status]}`}
    </div>
  );
}

function projectStatus(project) {
  const today = new Date();
  const start_date_s = project.start_date || project.year;
  const start_date = start_date_s && new Date(start_date_s);
  const end_date_s = project.end_date;
  const end_date = end_date_s && new Date(end_date_s);

  if (!start_date) {
    return null;
  } else if (today < start_date) {
    return 'pending';
  } else if (!end_date) {
    return null;
  } else if (today <= end_date) {
    return 'in_progress';
  } else {
    return 'finished';
  }
}

const STATUS_NAMES = {
  pending: 'Pending',
  in_progress: 'In progress',
  finished: 'Finished'
};

const STATUS_ICONS = {
  pending: '/images/status/pending.svg',
  in_progress: '/images/status/in_progress.svg',
  finished: '/images/status/finished.svg'
};
